import { AlgorithmSelectorGrid } from "../Components/AlgorithmSelectorGrid"

export const AlgorithmSelector = () => {

    return(
        <>
            <AlgorithmSelectorGrid />
        </>
    )
}